var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { PaymentTermType } from "../Constant";
import { parseDueInDaysFromApi } from "../SharedFunctions";
import { normalizeToStartOfDay, parseDateAsLocalOrNull, formatDateForDisplay, dateOnlyString, getInitialSelectedValue, getPaymentTermsTemplatesFromRedux, } from "./paymentTermsUtils";
export function PaymentTermsSelectorBL(_a) {
    var onPaymentTermsChange = _a.onPaymentTermsChange, initialValues = _a.initialValues;
    var templates = useSelector(getPaymentTermsTemplatesFromRedux);
    var _b = useState(function () { return getInitialSelectedValue(initialValues); }), selectedPaymentTermValue = _b[0], setSelectedPaymentTermValue = _b[1];
    var _c = useState(function () { var _a; return (_a = parseDateAsLocalOrNull(initialValues === null || initialValues === void 0 ? void 0 : initialValues.issueDate)) !== null && _a !== void 0 ? _a : normalizeToStartOfDay(new Date()); }), issueDate = _c[0], setIssueDate = _c[1];
    var _d = useState(function () {
        var d = parseDateAsLocalOrNull(initialValues === null || initialValues === void 0 ? void 0 : initialValues.customDueDate);
        if (d)
            return d;
        if ((initialValues === null || initialValues === void 0 ? void 0 : initialValues.paymentTermType) === PaymentTermType.FIXED)
            return normalizeToStartOfDay(new Date());
        return null;
    }), customDueDate = _d[0], setCustomDueDate = _d[1];
    var prevInitialRef = useRef("");
    var prevPayloadRef = useRef("");
    var paymentTermsOptions = useMemo(function () {
        try {
            if (!Array.isArray(templates))
                return [];
            return templates.map(function (template, index) {
                var _a, _b;
                var dueInDays = (_a = parseDueInDaysFromApi(template.dueInDays)) !== null && _a !== void 0 ? _a : null;
                var rawType = String(template.paymentTermsType || "")
                    .toLowerCase()
                    .replace(/\s+/g, "_");
                var templateId = ((_b = template.id) !== null && _b !== void 0 ? _b : template.Id);
                if (rawType === PaymentTermType.NET.toLowerCase() && dueInDays != null) {
                    return {
                        id: "".concat(PaymentTermType.NET, "_").concat(dueInDays),
                        description: String(template.description || template.name || ""),
                        paymentTermsType: PaymentTermType.NET,
                        dueInDays: dueInDays,
                        templateId: templateId,
                    };
                }
                if (rawType === PaymentTermType.RECEIPT.toLowerCase()) {
                    return {
                        id: PaymentTermType.RECEIPT,
                        description: String(template.description || template.name || ""),
                        paymentTermsType: PaymentTermType.RECEIPT,
                        dueInDays: null,
                        templateId: templateId,
                    };
                }
                if (rawType === PaymentTermType.FULFILLMENT.toLowerCase()) {
                    return {
                        id: PaymentTermType.FULFILLMENT,
                        description: String(template.description || template.name || ""),
                        paymentTermsType: PaymentTermType.FULFILLMENT,
                        dueInDays: null,
                        templateId: templateId,
                    };
                }
                if (rawType === PaymentTermType.FIXED.toLowerCase()) {
                    return {
                        id: PaymentTermType.FIXED,
                        description: String(template.description || template.name || ""),
                        paymentTermsType: PaymentTermType.FIXED,
                        dueInDays: null,
                        templateId: templateId,
                    };
                }
                return {
                    id: template.id || "unknown_".concat(index),
                    description: String(template.description || template.name || ""),
                    paymentTermsType: String(template.paymentTermsType || rawType),
                    dueInDays: dueInDays,
                    templateId: templateId,
                };
            });
        }
        catch (_a) {
            return [];
        }
    }, [templates]);
    var selectedOption = useMemo(function () {
        try {
            return paymentTermsOptions.find(function (opt) { return opt.id === selectedPaymentTermValue; });
        }
        catch (_a) {
            return undefined;
        }
    }, [paymentTermsOptions, selectedPaymentTermValue]);
    var derived = useMemo(function () {
        var _a;
        try {
            var paymentTermType = ((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.paymentTermsType) || PaymentTermType.RECEIPT);
            var dueInDays = paymentTermType === PaymentTermType.NET ? (_a = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.dueInDays) !== null && _a !== void 0 ? _a : undefined : undefined;
            var templateId = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.templateId;
            var dueDate = null;
            if (paymentTermType === PaymentTermType.NET && dueInDays != null) {
                dueDate = new Date(issueDate);
                dueDate.setDate(dueDate.getDate() + Math.max(0, dueInDays));
                dueDate = normalizeToStartOfDay(dueDate);
            }
            else if (paymentTermType === PaymentTermType.FIXED) {
                dueDate = customDueDate ? normalizeToStartOfDay(customDueDate) : null;
            }
            else if (paymentTermType === PaymentTermType.RECEIPT) {
                dueDate = normalizeToStartOfDay(new Date());
            }
            var finalIssueDate = paymentTermType === PaymentTermType.NET
                ? normalizeToStartOfDay(issueDate)
                : paymentTermType === PaymentTermType.FIXED && customDueDate
                    ? normalizeToStartOfDay(customDueDate)
                    : normalizeToStartOfDay(new Date());
            var payload = __assign(__assign(__assign(__assign({ paymentTermType: paymentTermType, issueDate: finalIssueDate }, (dueInDays != null ? { dueInDays: dueInDays } : {})), { customDueDate: paymentTermType === PaymentTermType.FIXED ? customDueDate !== null && customDueDate !== void 0 ? customDueDate : null : null, dueDate: dueDate }), (templateId ? { paymentTermsTemplateId: templateId } : {})), ((initialValues === null || initialValues === void 0 ? void 0 : initialValues.orderPaymentTermsId) != null ? { orderPaymentTermsId: initialValues.orderPaymentTermsId } : {}));
            return { paymentTermType: paymentTermType, dueInDays: dueInDays, templateId: templateId, dueDate: dueDate, payload: payload };
        }
        catch (_b) {
            var fallbackIssue = normalizeToStartOfDay(new Date());
            return {
                paymentTermType: PaymentTermType.RECEIPT,
                dueInDays: undefined,
                templateId: undefined,
                dueDate: fallbackIssue,
                payload: __assign({ paymentTermType: PaymentTermType.RECEIPT, issueDate: fallbackIssue, customDueDate: null, dueDate: fallbackIssue }, ((initialValues === null || initialValues === void 0 ? void 0 : initialValues.orderPaymentTermsId) != null ? { orderPaymentTermsId: initialValues.orderPaymentTermsId } : {})),
            };
        }
    }, [selectedOption, issueDate, customDueDate, initialValues === null || initialValues === void 0 ? void 0 : initialValues.orderPaymentTermsId]);
    var todayDateString = useMemo(function () {
        try {
            return formatDateForDisplay(new Date());
        }
        catch (_a) {
            return "";
        }
    }, []);
    var issueDateString = useMemo(function () {
        try {
            var formatted = issueDate ? formatDateForDisplay(issueDate) : "";
            return formatted || todayDateString;
        }
        catch (_a) {
            return todayDateString;
        }
    }, [issueDate, todayDateString]);
    var customDueDateString = useMemo(function () {
        try {
            return formatDateForDisplay(customDueDate);
        }
        catch (_a) {
            return "";
        }
    }, [customDueDate]);
    var issueDatePickerValue = useMemo(function () {
        try {
            return dateOnlyString(issueDate);
        }
        catch (_a) {
            return "";
        }
    }, [issueDate]);
    var customDueDatePickerValue = useMemo(function () {
        try {
            return dateOnlyString(customDueDate);
        }
        catch (_a) {
            return "";
        }
    }, [customDueDate]);
    var showIssueDateField = derived.paymentTermType === PaymentTermType.NET;
    var showFixedDateField = derived.paymentTermType === PaymentTermType.FIXED;
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        try {
            if (!initialValues)
                return;
            var key = JSON.stringify({
                paymentTermType: initialValues.paymentTermType,
                dueInDays: initialValues.dueInDays,
                issueDate: (_b = (_a = initialValues.issueDate) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a),
                customDueDate: (_d = (_c = initialValues.customDueDate) === null || _c === void 0 ? void 0 : _c.toString) === null || _d === void 0 ? void 0 : _d.call(_c),
                paymentTermsTemplateId: initialValues.paymentTermsTemplateId,
            });
            if (prevInitialRef.current === key)
                return;
            prevInitialRef.current = key;
            setSelectedPaymentTermValue(getInitialSelectedValue(initialValues));
            setIssueDate((_e = parseDateAsLocalOrNull(initialValues.issueDate)) !== null && _e !== void 0 ? _e : normalizeToStartOfDay(new Date()));
            setCustomDueDate(initialValues.paymentTermType === PaymentTermType.FIXED
                ? (_f = parseDateAsLocalOrNull(initialValues.customDueDate)) !== null && _f !== void 0 ? _f : normalizeToStartOfDay(new Date())
                : parseDateAsLocalOrNull(initialValues.customDueDate));
        }
        catch (_g) {
            setSelectedPaymentTermValue(PaymentTermType.RECEIPT);
            setIssueDate(normalizeToStartOfDay(new Date()));
            setCustomDueDate(null);
            onPaymentTermsChange(null);
        }
    }, [initialValues === null || initialValues === void 0 ? void 0 : initialValues.paymentTermType, initialValues === null || initialValues === void 0 ? void 0 : initialValues.dueInDays, initialValues === null || initialValues === void 0 ? void 0 : initialValues.issueDate, initialValues === null || initialValues === void 0 ? void 0 : initialValues.customDueDate, initialValues === null || initialValues === void 0 ? void 0 : initialValues.paymentTermsTemplateId]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        try {
            var serialized = JSON.stringify(__assign(__assign({}, derived.payload), { issueDate: (_b = (_a = derived.payload.issueDate) === null || _a === void 0 ? void 0 : _a.toISOString) === null || _b === void 0 ? void 0 : _b.call(_a), dueDate: (_e = (_d = (_c = derived.payload.dueDate) === null || _c === void 0 ? void 0 : _c.toISOString) === null || _d === void 0 ? void 0 : _d.call(_c)) !== null && _e !== void 0 ? _e : null, customDueDate: (_h = (_g = (_f = derived.payload.customDueDate) === null || _f === void 0 ? void 0 : _f.toISOString) === null || _g === void 0 ? void 0 : _g.call(_f)) !== null && _h !== void 0 ? _h : null }));
            if (prevPayloadRef.current === serialized)
                return;
            prevPayloadRef.current = serialized;
            onPaymentTermsChange(derived.payload);
        }
        catch (_j) {
            onPaymentTermsChange(null);
        }
    }, [derived.payload, onPaymentTermsChange]);
    var handlePaymentTermChange = function (event) {
        var _a, _b;
        try {
            var newValue = String((_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "");
            setSelectedPaymentTermValue(newValue);
            if (newValue === PaymentTermType.FIXED && !customDueDate) {
                setCustomDueDate(normalizeToStartOfDay(new Date()));
            }
            if (newValue.startsWith("".concat(PaymentTermType.NET, "_")) && !issueDate) {
                setIssueDate(normalizeToStartOfDay(new Date()));
            }
            if (newValue !== PaymentTermType.FIXED) {
                setCustomDueDate(null);
            }
        }
        catch (_c) {
            setSelectedPaymentTermValue(PaymentTermType.RECEIPT);
        }
    };
    var handleIssueDateChange = function (e) {
        var _a;
        try {
            var d = ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) ? parseDateAsLocalOrNull(new Date(e.target.value)) : null;
            if (d)
                setIssueDate(d);
        }
        catch (_b) {
            setIssueDate(new Date());
        }
    };
    var handleCustomDateChange = function (date) {
        try {
            setCustomDueDate(date ? normalizeToStartOfDay(date) : null);
        }
        catch (_a) {
            setCustomDueDate(null);
        }
    };
    var getDisplaySummary = function () {
        try {
            if (derived.paymentTermType === PaymentTermType.NET && derived.dueInDays != null)
                return "(Net ".concat(derived.dueInDays, ")");
            return "";
        }
        catch (_a) {
            return "";
        }
    };
    var getDateFormat = function (date) {
        try {
            if (!date)
                return "-";
            var d = date instanceof Date ? date : new Date(date);
            if (isNaN(d.getTime()))
                return "-";
            return "".concat(d.getDate(), " ").concat(d.toLocaleDateString("en-US", { month: "long" }), " ").concat(d.getFullYear());
        }
        catch (_a) {
            return "-";
        }
    };
    var getPaymentDueMessage = function () {
        try {
            if (derived.paymentTermType === PaymentTermType.RECEIPT) {
                return (_jsxs(_Fragment, { children: ["Payment due when \u00A0", _jsx("strong", { children: "invoice is sent" }), "."] }));
            }
            if (derived.paymentTermType === PaymentTermType.FULFILLMENT) {
                return (_jsxs(_Fragment, { children: ["Payment due when \u00A0", _jsx("strong", { children: "order is fulfilled" }), "."] }));
            }
            if (derived.paymentTermType === PaymentTermType.NET && derived.dueDate) {
                return (_jsxs(_Fragment, { children: ["Payment due on \u00A0", _jsxs("strong", { children: [getDateFormat(derived.dueDate), " ", getDisplaySummary()] }), ".", " "] }));
            }
            if (derived.paymentTermType === PaymentTermType.FIXED && derived.dueDate) {
                return (_jsxs(_Fragment, { children: ["Payment due on ", _jsx("strong", { children: getDateFormat(derived.dueDate) }), "."] }));
            }
            return "";
        }
        catch (_a) {
            return "";
        }
    };
    return {
        selectedPaymentTermValue: selectedPaymentTermValue,
        paymentTermsOptions: paymentTermsOptions,
        customDueDateString: customDueDateString,
        issueDateString: issueDateString,
        issueDatePickerValue: issueDatePickerValue,
        customDueDatePickerValue: customDueDatePickerValue,
        dueDate: derived.dueDate,
        handlePaymentTermChange: handlePaymentTermChange,
        handleIssueDateChange: handleIssueDateChange,
        handleCustomDateChange: handleCustomDateChange,
        getDisplaySummary: getDisplaySummary,
        getDateFormat: getDateFormat,
        getPaymentDueMessage: getPaymentDueMessage,
        todayDateString: todayDateString,
        showIssueDateField: showIssueDateField,
        showFixedDateField: showFixedDateField,
    };
}
